



export const APPLICATION_ID = '43e5ddac-d4b6-11ec-9d64-0242ac120002';


export const validator: unique symbol = Symbol('Validators');
export const validatorMap: unique symbol = Symbol('Validator Map');
export const validatorValueMap: unique symbol = Symbol('Validator Value Map');
export const attributes: unique symbol = Symbol('Attributes');
export const references: unique symbol = Symbol('References');
export const crudOptions: unique symbol = Symbol('CRUDOptions');
export const modelName: unique symbol = Symbol('Model Name');
export const displayName: unique symbol = Symbol('Display Name');
export const crudId: unique symbol = Symbol('Crud Unique Id');
export const fileAttributes: unique symbol = Symbol('File Attributes');
export const serialiseAs: unique symbol = Symbol('Serialise As');



export const Symbols = {
	validator: validator,
	validatorMap: validatorMap,
	attributes: attributes,
	references: references,
	crudOptions: crudOptions,
	modelName: modelName,
	displayName: displayName,
	crudId: crudId,
	fileAttributes: fileAttributes,
	validatorValueMap: validatorValueMap,
	serialiseAs: serialiseAs,
	
	
};
